import { fetchUserAttributes } from "aws-amplify/auth";

const USER_ATTRIBUTES_TTL_MS = 5 * 60 * 1000;

let userAttributesCache = null;
let userAttributesCachedAt = 0;
let userAttributesInflight = null;

export async function getCachedUserAttributes() {
  const now = Date.now();

  if (
    userAttributesCache &&
    now - userAttributesCachedAt < USER_ATTRIBUTES_TTL_MS
  ) {
    return userAttributesCache;
  }

  if (!userAttributesInflight) {
    userAttributesInflight = fetchUserAttributes()
      .then((attributes) => {
        userAttributesCache = attributes;
        userAttributesCachedAt = Date.now();
        return attributes;
      })
      .finally(() => {
        userAttributesInflight = null;
      });
  }

  return userAttributesInflight;
}

export function clearUserAttributesCache() {
  userAttributesCache = null;
  userAttributesCachedAt = 0;
}
